import { render, staticRenderFns } from "./FilesImageDisplay.vue?vue&type=template&id=70683392&"
import script from "./FilesImageDisplay.vue?vue&type=script&lang=js&"
export * from "./FilesImageDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports